/* Products and the theme editor's categories for the new header search's empty states (the machine's best sellers, or the picked collection): fetched ahead of need, kept for the session. */
(function () {
  'use strict';

  if (theme.searchBestSellers) return;

  const CACHE_PREFIX = 'search-best-sellers';
  const OPTION_SELECTOR = 'li[role="option"]';
  const CATEGORIES_SELECTOR = 'template[data-search-categories]';
  // Parsed once per URL for the page.
  const holders = {};
  const inFlight = {};

  // sections/predictive-search-best-sellers.liquid, for the URL's collection (filtered to a machine when it says so). Low priority,
  // so a search's own request goes first.
  function load(url) {
    const ready = peek(url);
    if (!url || ready) return Promise.resolve(ready);
    const key = cacheKey(url);
    if (!inFlight[key]) inFlight[key] = fetchHolder(url, key).finally(() => { delete inFlight[key]; });
    return inFlight[key];
  }

  function fetchHolder(url, key) {
    return fetch(url, { priority: 'low' })
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        if (!html) return null;
        writeCache(key, html);
        return keep(key, html);
      })
      .catch(() => null);
  }

  // What has arrived for this URL, from this page or this session's storage; null until then.
  function peek(url) {
    if (!url) return null;
    const key = cacheKey(url);
    if (holders[key]) return holders[key];
    const html = readCache(key);
    return html ? keep(key, html) : null;
  }

  // Parsed by the live document, as recently viewed cards are, so custom elements in the rows upgrade.
  function keep(key, html) {
    const holder = document.createElement('div');
    holder.innerHTML = html;
    holders[key] = holder;
    return holder;
  }

  // The product rows once they've arrived: fresh copies, as each call's rows go straight into a panel.
  function rows(url) {
    return load(url).then(copyRows);
  }

  // The product rows only if they've arrived (null otherwise), for a panel that mustn't wait.
  function readyRows(url) {
    const holder = peek(url);
    return holder ? copyRows(holder) : null;
  }

  // The editor's categories (search_empty_categories) only if they've arrived (null otherwise): rows to copy, not insert.
  function readyCategories(url) {
    const holder = peek(url);
    if (!holder) return null;
    const picks = holder.querySelector(CATEGORIES_SELECTOR);
    return picks ? Array.from(picks.content.querySelectorAll(OPTION_SELECTOR)) : [];
  }

  function copyRows(holder) {
    return holder ? Array.from(holder.querySelectorAll(OPTION_SELECTOR)).map((row) => row.cloneNode(true)) : [];
  }

  // Scoped like recently viewed cards, as a signed-in customer's best sellers leave out what they've bought.
  function cacheKey(url) {
    const scope = theme.recentlyViewed && theme.recentlyViewed.cacheScope ? theme.recentlyViewed.cacheScope() : 'anon';
    return `${CACHE_PREFIX}-${scope}-${url}`;
  }

  function readCache(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function writeCache(key, html) {
    try { sessionStorage.setItem(key, html); } catch (e) { /* quota or privacy mode: fetched again next time */ }
  }

  theme.searchBestSellers = { load, rows, readyRows, readyCategories };
})();
